import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        height: '100%',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF'
    },
    itemTitle: {
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        paddingRight: '0.5rem',
        paddingTop: '2rem',
        fontSize: '2rem',
        fontWeight: 'bold' as const,
        width: '100%',
        overflowWrap: 'break-word' as const
    },
    statusIcon: {
        marginRight: '.75rem',
        '&:last-child': { marginRight: 0 }
    },
    anchorText: {
        textDecorationLine: 'none' as const,
        color: theme?.app?.applicationColors.fontAnchorColor ||
            '#547dbf'
    },
    backBar: {
        flexBasis: 'auto',
        paddingLeft: '1rem',
        paddingTop: '2.25rem',
        paddingBottom: '1rem',
        fontSize: '1.2rem'
    },
    transactionHistoryButtonContainer: {
        height: 'auto' as const,
        alignSelf: 'center' as const,
        marginRight: 'auto' as const
    },
    tabBar: {
        padding: '.75rem 0',
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
            '#F3F3F3',
        flexBasis: 'auto'
    },
    tabRoot: {
        width: '15rem',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF'
    },
    tabIndicator: {
        top: '0',
        height: '5px',
        background: theme?.app?.clientTheme.colors.buttons.primaryColorLight ||
            '#009BDF'
    },
    tabContent: {
        padding: '0',
        flexGrow: 1,
        flexBasis: 'auto'
    },
    tabPanel: {
        height: '100%',
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '1rem 0'
    },
    topContent: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '0 1rem 2rem 3.5rem',
        flexBasis: 'auto'
    },
    headerStat: { width: '100%' },
    bubbleStats: { padding: '0' },
    indicator: {
        backgroundColor: theme?.app?.applicationColors.enumColors.greyDark ||
            '#333333'
    },
    currencyDropdownTitle: {
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        fontSize: '1rem',
        marginBottom: '0.2rem',
        fontWeight: 700,
        fontFamily: 'client-font,sans-serif'
    },
    currencyDropdown: {
        maxWidth: '300px',
        marginBottom: '0.5rem'
    }
});